<template>
  <div>
    <wc-data-box title='Authorizations' titleIcon='mdi-checkbox-marked-circle-outline' titleIconColor='success'
      :showEdit='!project.archived' @edit='editProject'>
      <v-simple-table outlined :dense='!notDense'>
        <thead></thead>
        <tbody>
          <tr v-for='(item, count) in items' :key='count'>
            <td class='grey--text text-left'>{{ item.text }}</td>
            <td class='text-right'>
              <v-icon v-if='typeof item.value === "boolean"' :color='item.value ? "success" : "error"' class='mr-n1'>
                {{ item.value ? "mdi-check" : "mdi-close" }}
              </v-icon>
              <span v-else>{{ item.value }}</span>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>

    <wc-dialog :showDialog='showDialog' title='Authorizations' icon='mdi-checkbox-marked-circle-outline'
      @cancel='showDialog = false' @save='saveProject' width='400'>
      <v-form v-model='isFormValid'>
        <v-checkbox hide-details v-model='projectCopy.project_detail.no_work_required' @change="setupChange('nwr')"
          label='No Work Required'></v-checkbox>
        <v-checkbox hide-details v-model='projectCopy.project_detail.su_authorized' @change="setupChange('sua')"
          label='Ongoing SU Authorized'></v-checkbox>
        <v-checkbox hide-details v-model='projectCopy.project_detail.bd_authorized' @change="setupChange('bda')"
          label='Ongoing BD Authorized'></v-checkbox>
        <v-checkbox v-if='project.is_comm' hide-details v-model='projectCopy.project_detail.post_sept_bd'
          label='BD PS20?'></v-checkbox>
        <v-checkbox :disabled='project.is_comm' v-model='projectCopy.project_detail.can_have_bm8'
          label='Can this system have BM8/ES10 option?' :persistent-hint='project.is_comm'
          :hint='project.is_comm ? "Commercial Projects cannot have the BM8/ES10 option" : ""'></v-checkbox>
        <v-checkbox hide-details v-model='projectCopy.needs_key' label='Is a key needed for the SU/BD?'></v-checkbox>
        <v-checkbox hide-details v-model='projectCopy.needs_po' label='Is a PO needed for the SU/BD?'></v-checkbox>
      </v-form>
    </wc-dialog>

    <wc-confirm :showDialog='showConfirm' @cancel='showConfirm = false; showDialog = false'
      @confirm='confirmAuthChange'>
      Whoa there, wait a minute! Changing this setting can have some pretty dire consequences.<br>
      <br>
      If staging for SU/BD has already begun make sure to <strong>FIND THE SYSTEM IN STAGING AND DO THE APPROPRIATE
        ACTION TO THE SYSTEM FOR THIS YEAR.</strong><br>
      <br>
      (Changing it here will affect long term but for this year you will also need to move the system where you want it
      to be in staging. Example: If you are changing a system from “no work required” to “authorized” you will need to
      find it in the cancelled section and un-cancel this year as well.)<br>
      <br>
      Please make sure you REALLY want to change this!<br>
    </wc-confirm>

    <wc-dialog :showDialog='showActionDialog' title='Action' icon='mdi-message-text'
      @cancel='showActionDialog = false; showConfirm = false; showDialog = false;' @save='saveAction'
      :disableButtons='!isActionFormValid'>
      <v-form v-model='isActionFormValid' ref='actionForm'>
        <v-textarea label='Please specify a reason for making this change' v-model='actionDescription'
          :rules='[rules.required]' outlined></v-textarea>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules';
import moment from 'moment';
import trackerAPI from "@/api/tracker";

export default {
  name: 'irrigations-authorizations',
  mixins: [formRules],
  props: {
    project: {
      required: true
    },
    notDense: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showDialog: false,
    showConfirm: false,
    projectCopy: { project_detail: {} },
    actionDescription: '',
    changeDescription: '',
    isActionFormValid: false,
    showActionDialog: false,
  }),
  computed: {
    items() {
      let tmp = [
        { text: 'No work Required', value: this.project.project_detail.no_work_required },
        { text: 'Ongoing SU Authorized', value: this.project.project_detail.su_authorized },
        { text: 'Ongoing BD Authorized', value: this.project.project_detail.bd_authorized }
      ]
      tmp.push({ text: 'Can this system have the BM8/ES10 option?', value: this.$options.filters.trueFalse(this.project.project_detail.can_have_bm8) })
      tmp.push({ text: 'Is a key needed for the SU/BD?', value: this.$options.filters.trueFalse(this.project.needs_key) })
      tmp.push({ text: 'Is a PO needed for the SU/BD?', value: this.$options.filters.trueFalse(this.project.needs_po) })
      return tmp
    }
  },
  methods: {
    editProject() {
      this.projectCopy = _.cloneDeep(this.project)
      this.showDialog = true
    },
    saveProject() {
      this.$emit('update', this.projectCopy)
      this.showDialog = false
      this.showConfirm = false
    },
    confirmAuthChange() {
      if (this.projectCopy.project_detail.no_work_required) {
        this.projectCopy.project_detail.su_authorized = false
        this.projectCopy.project_detail.bd_authorized = false
      }
      this.showActionDialog = true
    },
    setupChange(val) {
      /*
      nwr --> NWR was clicked
      sua --> SU Auth was clicked
      bda --> BD Auth was clicked
      */
      if (val === 'nwr') {
        if (this.projectCopy.project_detail.no_work_required) {
          this.projectCopy.project_detail.su_authorized = false
          this.projectCopy.project_detail.bd_authorized = false
          this.changeDescription = "NWR turned on";
        }
        else {
          this.changeDescription = "NWR turned off";
        }
      }
      if (val === 'sua') {
        this.projectCopy.project_detail.no_work_required = false
        if (this.projectCopy.project_detail.su_authorized) {
          this.changeDescription = "SU Auth turned on";
        }
        else {
          this.changeDescription = "SU Auth turned off";
        }
      }

      if (val === 'bda') {
        this.projectCopy.project_detail.no_work_required = false
        if (this.projectCopy.project_detail.bd_authorized) {
          this.changeDescription = "BD Auth turned on";
        }
        else {
          this.changeDescription = "BD Auth turned off";
        }
      }
      this.showConfirm = true
    },
    async saveAction() {
      const tracker_data = {
        'description': this.actionDescription,
        'action': this.changeDescription,
        'taken_by': this.$store.state.auth.profile.id,
        'action_date': moment().format('YYYY-MM-DD').toString(),
      }
      const tracker = {
        'tracker_data': tracker_data,
        'project': this.projectCopy.id
      };
      await trackerAPI.createProjectTracker(tracker);
      this.showActionDialog = false

      this.saveProject()
    },
  }
}
</script>
